const component = "programming-range-form-dialog";

export const programmingRangeFormDialog = {
  component,
  title: `${component}/title`,
  subtitle: `${component}/subtitle`,
  cancelButton: `${component}/cancel-button`,
  submitButton: `${component}/submit-button`,
};
